import { SeatType } from '@vista-digital/ocapi-types/v1';
import { translatableValidator } from '@vista-digital/ocapi-utilities';
import { Validator } from '@vista-digital/validator';
export const defaultOccSeatingLegendItems = [
    {
        label: 'Available',
        seatType: SeatType.Normal
    },
    {
        label: 'Unavailable',
        seatType: SeatType.Normal,
        showAsUnavailable: true
    },
    {
        label: 'Your Selection',
        seatType: SeatType.Normal,
        showAsSelected: true
    },
    {
        label: 'Wheelchair Space',
        seatType: SeatType.Wheelchair
    },
    {
        label: 'Companion',
        seatType: SeatType.Companion
    },
    {
        label: 'House',
        seatType: SeatType.Normal,
        showAsHouse: true,
        showAsUnavailable: true
    }
];
export const occSeatingLegendItemConfigValidator = Validator.object({
    label: Validator.any([Validator.nonEmptyString, translatableValidator]),
    seatType: Validator.oneOf(Object.values(SeatType)),
    showAsUnavailable: Validator.optional(Validator.boolean()),
    showAsSelected: Validator.optional(Validator.boolean()),
    showAsFriend: Validator.optional(Validator.boolean()),
    showAsHouse: Validator.optional(Validator.boolean()),
    customIconName: Validator.optional(Validator.nonEmptyString),
    customClass: Validator.optional(Validator.nonEmptyString),
    appearanceRuleId: Validator.optional(Validator.nonEmptyString)
});
//# sourceMappingURL=legend-item.js.map